import { test } from '@playwright/test';
import { onFormSubmitCallback } from '../playwright-util/form';
import { expect } from '../playwright-util/custom-matchers';

test.describe('radio-component', () => {
	test.beforeEach(async ({ page }) => {
		await page.goto('iframe.html?viewMode=docs&id=test-radio--docs');
	});

	test('visibility', async ({ page }) => {
		await expect(page.locator('#with-label')).toBeVisible();
		await expect(page.locator('#unchecked')).toBeVisible();
		await expect(page.locator('#checked')).toBeVisible();
		await expect(page.locator('#custom-value')).toBeVisible();
		await expect(page.locator('#disabled')).toBeVisible();
		await expect(page.locator('#checked-disabled')).toBeVisible();
	});

	test('states', async ({ page }) => {
		const radioWithLabel = page.locator('#with-label');
		await expect(radioWithLabel).isNotChecked();

		const uncheckedRadio = page.locator('#unchecked');
		await expect(uncheckedRadio).isNotChecked();

		const checkedRadio = page.locator('#checked');
		await expect(checkedRadio).isChecked();

		const disabledRadio = page.locator('#disabled');
		await expect(disabledRadio).toHaveAttribute('disabled', '');

		const checkedDisabledRadio = page.locator('#checked-disabled');
		await expect(checkedDisabledRadio).isChecked();
		await expect(checkedDisabledRadio).toHaveAttribute('disabled', '');
	});

	test('interaction', async ({ page }) => {
		await page.getByLabel('Radio button with label').click();
		const radioWithLabel = page.locator('#with-label');
		await expect(radioWithLabel).isChecked();

		const uncheckedRadio = page.locator('#unchecked');
		await uncheckedRadio.click();
		await expect(uncheckedRadio).isChecked();

		const disabledRadio = page.locator('#disabled');
		await disabledRadio.click();
		await expect(disabledRadio).isNotChecked();

		const checkedDisabledRadio = page.locator('#checked-disabled');
		await checkedDisabledRadio.click();
		await expect(checkedDisabledRadio).isChecked();
	});

	test('form-submission', async ({ page }) => {
		const getFormData = await onFormSubmitCallback(page, 'radio-form');

		const radioGroupMember = page.locator('#group-member-1');
		await radioGroupMember.click();

		const radioGroupMember2 = page.locator('#group-member-2');
		await radioGroupMember2.click();

		const radioGroupMember3 = page.locator('#group-member-3');
		await radioGroupMember3.click();

		await page.locator('#submit-button').click();

		await expect.poll(async () => (await getFormData()) !== null, 'Form data not received').toBeTruthy();
		const formData = await getFormData();

		expect(formData).toMatchObject({
			checked: 'on',
			'custom-value': 'custom-value',
			'radio-group': 'option-3',
		});
		expect(formData).not.toHaveProperty('unchecked');
		expect(formData).not.toHaveProperty('disabled');
		expect(formData).not.toHaveProperty('checked-disabled');
	});

	test('form-reset', async ({ page }) => {
		await page.locator('#unchecked').click();
		await page.locator('#checked').click();

		await page.locator('#reset-button').click();

		await expect(page.locator('#unchecked')).isNotChecked();
		await expect(page.locator('#checked')).isChecked();
	});
});
